/**
 * Limits numerical value between two number
 */
export const limitValue = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}
